const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

const reviver = (key: string, value: any) =>
  typeof value === "string" && dateFormat.test(value)
    ? new Date(value)
    : value;

export default reviver;